export function setRef(a,b){"function"==typeof a?a(b):a&&(a.current=b)}
//# sourceMappingURL=setRef.js.map